import get from 'lodash/get'

import { dateFns as moment } from '@pcln/date-fns-utils'
import { packageBasePath, DEFAULT_CHILD_AGE, DEFAULT_INFANT_AGE } from '../../common/constants/constants'
import { getPkgRguid } from '../../utils/getPkgRguid'
import { getNegotiatorapp } from '@mfs/client/utils/getNegotiatorapp'
import { updatePaidBags } from '../util/handleDetailsCheckout/handleDetailsCheckout'
import { v4 as uuidv4 } from 'uuid'
import { translatePassengersToPkg } from '../util/translatePassengersToPkg'

export const toCartCheckout = (cartCheckoutObj) => {
  const host = globalThis.window.location.origin
  const pkgRguid = getPkgRguid()
  const formUrl = `${host}${packageBasePath}/itinerary${pkgRguid ? `?pkg-rguid=${pkgRguid}` : ''}`
  const form = document.createElement('form')
  form.setAttribute('method', 'POST')
  form.setAttribute('action', formUrl)
  for (const prop in cartCheckoutObj) {
    const input = document.createElement('input')
    input.name = prop
    input.type = 'hidden'
    input.value =
      typeof cartCheckoutObj[prop] === 'object'
        ? JSON.stringify(cartCheckoutObj[prop])
        : cartCheckoutObj[prop]
    form.appendChild(input)
  }
  document.body.appendChild(form)
  form.submit()
}
export const toShopSearchRedirect = async (shopSearchObject) => {
  const host = globalThis.window.location.origin
  const pkgRguid = getPkgRguid()
  const negotiatorapp = getNegotiatorapp()
  let formUrl = `${host}${packageBasePath}/redirect${pkgRguid ? `?pkg-rguid=${pkgRguid}` : ''}`
  if (negotiatorapp) {
    formUrl += (formUrl.indexOf('?') > 0 ? '&' : '?') + `negotiatorapp=${negotiatorapp}`
  }
  const form = document.createElement('form')
  form.setAttribute('method', 'POST')
  form.setAttribute('action', formUrl)
  for (const prop in shopSearchObject) {
    const input = document.createElement('input')
    input.name = prop
    input.type = 'hidden'
    input.value =
      typeof shopSearchObject[prop] === 'object'
        ? JSON.stringify(shopSearchObject[prop])
        : shopSearchObject[prop]
    form.appendChild(input)
  }
  document.body.appendChild(form)
  form.submit()
}

export const buildShopSearchXsellUrl = ({ xsellObject, pclnBootstrapData }) => {
  const { searchRequest, requestLocals } =
    pclnBootstrapData || (typeof window !== 'undefined' && window.PCLN_BOOTSTRAP_DATA)

  const { uspCacheKey } = requestLocals || {}

  const { params, slices, airports } = searchRequest || {}

  const numAdults = Number(get(params, 'num-adults') || 0)
  const numChild = Number(get(params, 'num-children') || 0)
  const numInfants = Number(get(params, 'num-infants') || 0)

  const children = [...Array(numChild).fill(DEFAULT_CHILD_AGE), ...Array(numInfants).fill(DEFAULT_INFANT_AGE)]

  const departureCitySearchAirport = slices?.[0]?.originAirport ?? ''
  const returnCitySearchAirport = slices?.[0]?.destinationAirport ?? ''

  const {
    packageTypeCode,
    numRooms,
    departureAirport,
    returnAirport,
    flyKey,
    flyItemKey,
    flyPriceKey,
    stayKey,
    preferredhotelids,
    flySessionKey,
    flySlices,
    travelStartDateOverride,
    travelEndDateOverride,
    departureCityNameOverride,
    returnCityNameOverride,
  } = xsellObject ?? {}

  const travelStartDate = travelStartDateOverride ?? slices?.[0]?.travelDate
  const travelEndDate = travelEndDateOverride ?? slices?.[1]?.travelDate

  const departureCityName =
    departureCityNameOverride ?? airports?.[departureCitySearchAirport]?.cityName ?? ''
  const returnCityName = returnCityNameOverride ?? airports?.[returnCitySearchAirport]?.cityName ?? ''

  const urlParams = new URLSearchParams()
  if (uspCacheKey) {
    urlParams.set('uspCacheKey', uspCacheKey)
  }
  urlParams.set('packageTypeCode', packageTypeCode)
  urlParams.set('numRooms', numRooms)
  urlParams.set('pivot', 'FLY')
  urlParams.set('travelStartDate', travelStartDate)
  urlParams.set('travelEndDate', travelEndDate)
  urlParams.set('departureAirport', departureAirport)
  urlParams.set('returnAirport', returnAirport)
  urlParams.set('numAdults', numAdults)
  if (flyKey) {
    urlParams.set('flyKey', flyKey)
  }
  urlParams.set('flyItemKey', flyItemKey)
  urlParams.set('flyPriceKey', flyPriceKey)
  if (stayKey) {
    urlParams.set('stayKey', stayKey)
  }
  urlParams.set('departureCityName', departureCityName)
  urlParams.set('returnCityName', returnCityName)
  if (children.length > 0) {
    urlParams.set('childAges', children.join(','))
  }
  if (preferredhotelids) {
    urlParams.set('preferredhotelids', preferredhotelids)
  }
  if (flySessionKey) {
    urlParams.set('flySessionKey', flySessionKey)
  }
  if (flySlices) {
    urlParams.set('flySlices', flySlices)
  }
  return `/shop/search/xsell?` + urlParams.toString()
}
export const toShopSearchXsell = async (
  { xsellObject, itinDetails, pclnBootstrapData },
  location = globalThis.window.location
) => {
  const bags = updatePaidBags()

  const { searchRequest } = pclnBootstrapData || (typeof window !== 'undefined' && window.PCLN_BOOTSTRAP_DATA)
  const travelers = translatePassengersToPkg(searchRequest, itinDetails.passengers)
  const shopSearchObject = {
    ...xsellObject,
    numAdults: travelers.adults,
    children: [
      ...Array(travelers.children).fill({ lapChild: false, age: DEFAULT_CHILD_AGE }),
      ...Array(travelers.infants).fill({ lapChild: true, age: DEFAULT_INFANT_AGE }),
    ],
    departureAirport: itinDetails.slices[0].departInfo.airport.code,
    arrivalAirport: itinDetails.slices[0].arrivalInfo.airport.code,
    travelStartDate: moment(itinDetails.slices[0].departInfo.time.dateTime).format('YYYY-MM-DD'),
    travelEndDate: moment(itinDetails.slices[1].departInfo.time.dateTime).format('YYYY-MM-DD'),
    flyArrivalDateTime: itinDetails.slices[0].arrivalInfo.time.dateTime,
    flyReturnDateTime: itinDetails.slices[1].departInfo.time.dateTime,
    departureCityName: itinDetails.slices[0].departInfo.airport.displayLocation,
    arrivalCityName: itinDetails.slices[0].arrivalInfo.airport.displayLocation,
    ...(bags ? { flyAncillary: { bags } } : {}),
  }

  const host = location.origin
  const pkgRguid = getPkgRguid() || uuidv4()
  let formUrl = `${host}${packageBasePath}/xsell${pkgRguid ? `?pkg-rguid=${pkgRguid}` : ''}`
  const form = document.createElement('form')
  form.setAttribute('method', 'POST')
  form.setAttribute('action', formUrl)
  form.setAttribute('target', '_blank')
  for (const prop in shopSearchObject) {
    const input = document.createElement('input')
    input.name = prop
    input.type = 'hidden'
    input.value =
      typeof shopSearchObject[prop] === 'object'
        ? JSON.stringify(shopSearchObject[prop])
        : shopSearchObject[prop]
    form.appendChild(input)
  }
  document.body.appendChild(form)
  form.submit()
}
